import _ from 'lodash'
import { ALL_SIZES } from 'scoreboard/dashboards/widgets/font-size-menu'

export default function (selection) {
	selection
		.call(updateFill)
		.call(updateTrendColor)
		.call(updateOutsideFontSizeClass)
}

/**
 * A function to help applying one of a set of commonly-prefixed classes to a d3 selection.
 * This should be used with _.partial() to build a d3 selection function for a specific set of classes.
 * See updateFill for explanation of a specific example.
 */
function updateMultipleChoiceClass (prefix, choices, predicate, selection) {
	choices = _.isFunction(choices) ? choices() : choices
	_.each(choices, function (choice) {
		selection.classed(prefix + '-' + choice, _.partial(predicate, choice))
	})
}

/**
 * Applies the appropriate fill class (fill-solid, fill-linear, or fill-none) to the d3 selection,
 * based on the dashboard node's 'fill' property. Will also ensure that any previous fill-* properties
 * are removed.
 */
var fills = ['solid', 'linear', 'none']
var updateFill =  _.partial(updateMultipleChoiceClass, 'fill', fills, function (f, d) {
	return d.properties.fill == f
})

/**
 * Applies the appropriate trend color class (trend-color-green, trend-color-red, etc) to the d3 selection,
 * and ensures that any previous trend-color-* properties are removed.
 */
var trendColors = ['gray', 'green-medium', 'red-medium', 'slate']
var updateTrendColor = _.partial(updateMultipleChoiceClass, 'trend-color', trendColors, function (c, d) {
	let color = _.get(d, 'domainData.trend.color') || 'gray'

	return color === c
})

/**
 * Applies the appropriate outside font size class (outside-font-size-10, outside-font-size-13, etc) to the d3 selection,
 * and ensures that any previous outside-font-size-* properties are removed.
 */
var updateOutsideFontSizeClass = _.partial(updateMultipleChoiceClass, 'outside-font-size', ALL_SIZES, function (size, d) {
	return d.properties.outsideFontSize == size
})
